import * as React from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import { useEffect } from 'react';
import Map from './Map';
import { currentLocationPos, PractitionerOrOrganization } from '../../../../interfaces/interfaces';
import MarkerWithInfoWindow from './Map/MarkerWithInfoWindow';

interface MarkerProps {
  resourceArr: Map<string, PractitionerOrOrganization>;
  markerPractArr?: PractitionerOrOrganization;
  setCurrentLocation(x: currentLocationPos | null): void;
  children: React.ReactNode;
}

const render = (status: Status) => {
  return <h1>{status}</h1>;
};

const MapSection: React.VFC<MarkerProps> = ({ resourceArr, markerPractArr, setCurrentLocation, children }: MarkerProps) => {
  const [zoom, setZoom] = React.useState(4);
  const [center, setCenter] = React.useState<google.maps.LatLngLiteral>({
    lat: 56,
    lng: -112,
  });

  const { location } = markerPractArr ?? { location: { lat: 56, lng: -112 } };
  const deltaForMarker = 0.015;

  useEffect(() => {
    if (markerPractArr) {
      setZoom(15);
      setCenter({
        lat: location.lat,
        lng: location.lng - deltaForMarker,
      });
    } else {
      setZoom(4);
    }
  }, [markerPractArr, location]);

  return (
    <Wrapper apiKey={`${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`} render={render}>
      <Map style={{ flexGrow: '1', height: '100%', position: 'relative' }} center={center} zoom={zoom} setCurrentLocation={setCurrentLocation}>
        {[...resourceArr.values()].map((item) => {
          return <MarkerWithInfoWindow item={item} key={item.id} position={item.location} />;
        })}
        {children}
      </Map>
    </Wrapper>
  );
};

export default MapSection;
